// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageWithOverlay-module--image--3XJH8","overlay":"ImageWithOverlay-module--overlay--3SY2m"};